import { Table, TableColumnsType } from 'antd'
import dayjs from 'dayjs'

import { ONLY_DATE_FORMAT } from '../../../../../constants/global'
import { numberFormat } from '../../../../../utils'
import { IDailyReportRow } from '../types'

interface Props {
  data: IDailyReportRow[]
  isLoading?: boolean
}

// สีตามเครื่องหมาย: บวก=เขียว ลบ=แดง ศูนย์=ปกติ
const signStyle = (value: number) =>
  value > 0
    ? { color: '#389e0d' }
    : value < 0
      ? { color: '#cf1322' }
      : undefined

const moneyCell = (value: number) => (
  <span style={signStyle(value)}>{numberFormat(value)}</span>
)

const DailyTable = ({ data, isLoading }: Props) => {
  const columns: TableColumnsType<IDailyReportRow> = [
    {
      title: 'วันที่',
      dataIndex: 'date',
      key: 'date',
      render: (date: string) => dayjs(date).format(ONLY_DATE_FORMAT),
    },
    {
      title: 'ออเดอร์',
      dataIndex: 'count',
      key: 'count',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: 'ชิ้น',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: 'COD (฿)',
      dataIndex: 'codTotal',
      key: 'codTotal',
      align: 'right',
      render: moneyCell,
    },
    {
      title: 'โอน (฿)',
      dataIndex: 'transferTotal',
      key: 'transferTotal',
      align: 'right',
      render: moneyCell,
    },
    {
      title: 'ยอดรวม (฿)',
      dataIndex: 'grandTotal',
      key: 'grandTotal',
      align: 'right',
      render: moneyCell,
    },
    {
      title: 'ต้นทุนสินค้า (฿)',
      dataIndex: 'costTotal',
      key: 'costTotal',
      align: 'right',
      render: moneyCell,
    },
    {
      title: 'กำไรขั้นต้น (฿)',
      key: 'grossProfit',
      align: 'right',
      render: (_, record) =>
        moneyCell((record.grandTotal ?? 0) - (record.costTotal ?? 0)),
    },
    {
      title: 'ยอดขายสำเร็จ (฿)',
      dataIndex: 'successTotal',
      key: 'successTotal',
      align: 'right',
      render: moneyCell,
    },
  ]

  return (
    <Table
      rowKey="date"
      columns={columns}
      dataSource={data}
      loading={isLoading}
      pagination={false}
      scroll={{ x: 'max-content' }}
    />
  )
}

export default DailyTable
